var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-menu',{attrs:{"background-color":"#3C5179","text-color":"#fff","active-text-color":"#4460C4","unique-opened":"","collapse":_vm.isCollapse,"collapse-transition":false,"router":true,"default-active":_vm.$route.path}},[_c('sidebar-item',{attrs:{"menu":_vm.getrouters()}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }